import { useEffect } from 'react';
import { trackingRedirectToRegistrationPage } from '../tracking';

type RedirectToRegistrationPageProps = Readonly<{
  testGroup?: string;
  redirectUrl: string;
}>;

export default function RedirectToRegistrationPage({
  testGroup,
  redirectUrl,
}: RedirectToRegistrationPageProps) {
  useEffect(() => {
    trackingRedirectToRegistrationPage(testGroup ?? 'unknown');
    window.location.replace(redirectUrl);
  }, [redirectUrl, testGroup]);
  return null;
}
